import React, { useState } from 'react';
// Utils
import { isEmptyObject } from 'utils';
// Admin Context
import { useAdminDispatch, useAdminState } from 'context/AdminContext';
import { setUser } from 'context/AdminContext/actions';
import { GET_USER } from 'context/AdminContext/statusFlags';
// Assets
import Icon from 'assets/Icon';
// Elements
import Button from 'elements/Button';
import { SearchField } from 'elements/Forms';
import { Loading } from 'elements/Loading';
// Style
import styles from './style/userSearchBar.module.css';

function UserSearchBar({ handleSubmit }: { handleSubmit: Function }) {
  // Admin State
  const adminDispatch = useAdminDispatch();
  const { adminState, user } = useAdminState();
  // State
  const [userId, setUserId] = useState('');
  const disabled = (userId.length < 8 || adminState === GET_USER || user && user.id === userId);

  function handleChange(e:{ target: HTMLInputElement }) {
    const { validity: { valid }, value } = e.target;
    if (valid) {
      setUserId(value);
    }
    if (!isEmptyObject(user)) {
      adminDispatch(setUser({}));
    }
  }

  function handleKeydown(e:React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Enter') {
      handleSubmit(userId);
    }
  }

  function setRemainingChars(minLength:number, str:string) {
    const remaining = minLength - str.length;
    if (remaining === minLength) {
      return '';
    }
    if (remaining <= 0) {
      return <Icon icon="tick" fill="fresh-green" size={18} />;
    }
    return `Minimum ${remaining} number(s) remaining`;
  }

  return (
    <div className={styles.container}>
      <SearchField
        icon={false}
        keydownHandler={(e:React.KeyboardEvent<HTMLInputElement>) => handleKeydown(e)}
        onChangeHandler={(e:React.ChangeEvent<HTMLInputElement>) => handleChange(e)}
        onPasteHandler={(e:React.ChangeEvent<HTMLInputElement>) => handleChange(e)}
        placeholderText="Enter 8 or 9 Digit Employee ID"
        value={userId}
        pattern="([0-9]{0,8})||([0-9]{0,9})"
        maxLength={9}
        validationMessage={setRemainingChars(8, userId)}
      />
      <div className={styles.submit}>
        <Button
          btnSize="small"
          btnStyle="secondary"
          btnType="icon"
          disabled={disabled}
          handler={() => handleSubmit(userId)}
          label="Search"
        >
          {adminState === 'GET_USER' ? (
            <Loading size={24} fill="white" />
          ) : (
            <Icon icon="Search" size={24} fill="white" />
          )}
        </Button>
      </div>
    </div>
  );
}

export default UserSearchBar;
